import { navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { cn } from "@/lib";
import { NavType } from "@/types";
import { LinkWithParams } from "../LinkWithParams";

export const NavLink = ({ href, label, Icon }: NavType) => {
  return (
    <LinkWithParams
      href={href}
      className={cn(navigationMenuTriggerStyle(), "w-full justify-start gap-2")}
    >
      {Icon && <Icon size={16} className="text-muted-foreground" />} {label}
    </LinkWithParams>
  );
};
